<template>
  <div>
    <div class="page_title">每日中药列表</div>
    <div style="padding:20px;border-radius:5px;">
      <div class="container">
        <div class="addbox">
          <div>
            <el-button
              type="primary"
              icon="el-icon-plus"
              @click="addexample"
              style="width:120px"
            >添加文章</el-button>
          </div>
        </div>
        <div style="border: solid 1px #c9cbd6;">
          <el-table
            ref="multipleTable"
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%;min-width:1000px;"
            :header-cell-style="{background:'#F5F5F5'}"
          >
            <el-table-column label="标题" prop="title"></el-table-column>
            <el-table-column label="作者" prop="author"></el-table-column>
            <el-table-column label="编辑时间" prop="update_time"></el-table-column>
            <el-table-column label="状态">
              <template slot-scope="scope">
                <span v-if="scope.row.status==1">待发布</span>
                <span v-if="scope.row.status==2">已发布</span>
                <span v-if="scope.row.status==3">已下架</span>
              </template>
            </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button
                  @click="edit(scope.row.art_id,scope.row.status)"
                  type="text"
                  size="medium"
                >详情</el-button>
                <el-button
                  @click="editStatus(scope.row.art_id,3)"
                  type="text"
                  size="medium"
                  v-if="scope.row.status==2"
                >下架</el-button>
                <el-button
                  @click="editStatus(scope.row.art_id,2)"
                  type="text"
                  size="medium"
                  v-if="scope.row.status==3||scope.row.status==1"
                >发布</el-button>
                <el-button @click="delexample(scope.row.art_id)" type="text" size="medium">删除</el-button>
              </template>
            </el-table-column>

            <el-table-column label="排序">
              <template slot-scope="scope">
                <el-button
                  @click="updateSort(scope.$index,1)"
                  size="medium"
                  type="text"
                  icon="el-icon-upload2"
                  style="font-size:20px"
                ></el-button>

                <el-button
                  @click="updateSort(scope.$index,2)"
                  size="medium"
                  type="text"
                  icon="el-icon-download"
                  style="font-size:20px"
                ></el-button>

                <el-button
                  @click="updateSort(scope.$index,3)"
                  size="medium"
                  type="text"
                  icon="el-icon-top"
                  style="font-size:20px"
                ></el-button>
                <el-button
                  @click="updateSort(scope.$index,4)"
                  size="medium"
                  type="text"
                  icon="el-icon-bottom"
                  style="font-size:20px"
                ></el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import imgtext from "../../../api/imgtext";
import platform from "../../../api/platform";
export default {
  data() {
    return {
      detail: {},
      tableData: [],
      title: this.$route.query.title
    };
  },

  methods: {
    //获取列表
    getList() {
      imgtext.getDailyChineseMedicineList().then(res => {
        if (res.code == 0) {
          this.tableData = res.data.list.map(item => {
            item.update_time = platform.timestampToTime(item.update_time);
            return item;
          });
        }
      });
    },
    //排序
    updateSort(index, status) {
      let data = this.tableData[index];
      this.tableData.splice(index, 1);
      //置顶
      if (status == 1) {
        this.tableData.splice(0, 0, data);
      }
      //置底
      if (status == 2) {
        this.tableData.push(data);
      }
      //上移
      if (status == 3) {
        this.tableData.splice(index - 1, 0, data);
      }
      //下移
      if (status == 4) {
        this.tableData.splice(index + 1, 0, data);
      }
      let list = [];
      list = this.tableData.map(item => {
        item = _.pick(item, ["art_id", "sort"]);
        return item;
      });
      imgtext.editDailyChineseMedicineSort({ list }).then(res => {
        if (res.code == 0) {
          this.getList();
        }
      });
    },
    //添加
    addexample() {
      this.$router.push("addmedicine");
    },
    //编辑
    edit(art_id, status) {
      if (status == 2) {
        this.$router.push({
          path: "medicinedetial",
          query: {
            art_id
          }
        });
      } else {
        this.$router.push({
          path: "addmedicine",
          query: {
            art_id
          }
        });
      }
    },
    //修改状态
    editStatus(art_id, status) {
      imgtext.changeDailyChineseMedicineStatus({ art_id, status }).then(res => {
        if (res.code == 0) {
          this.$message.success("已修改发布状态");
          this.getList();
        }
      });
    },
    //删除
    delexample(art_id) {
      this.$confirm("确定要删除吗？", "提示消息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消"
      }).then(() => {
        imgtext.deleteDailyChineseMedicineInfo({ art_id }).then(res => {
          if (res.code == 0) {
            this.$message.success("删除成功");
            this.getList();
          }
        });
      });
    }
  },
  created() {
    this.getList();
  }
};
</script>

<style lang="scss" scoped>
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
  padding: 20px;
  text-align: left;
}
.addbox {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}
</style>

